export const environment = {
  production: true,
  // ruta: "https://api.ieeg.org.mx/EleccionesEscolares/",
  ruta: "https://api.ieeg.mx/EleccionesEscolares/",
  version: "1.0.1"
};
